export const IsReadOnlyTaskByName = (status: string) => {
    switch (status.toLowerCase()) {
        case "not yet started":
        case "not yet due":
            return false;
        default:
            return true;
    }
};
